import { Routes } from '@angular/router';

import { NotFoundComponent } from '@naturfond/common';
import { HomeComponent, PrivacyPolicyComponent, TermsOfUseComponent } from './components';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'index.html',
    component: HomeComponent,
  },
  {
    path: 'lyngbakkerne',
    loadChildren: () => import('./features/lyngbakkerne/lyngbakkerne.routes').then(m => m.routes),
  },
  {
    path: 'støtteforeningen',
    loadChildren: () => import('./features/foreningen/foreningen.routes').then(m => m.routes),
  },
  {
    path: 'fonden',
    loadChildren: () => import('./features/fonden/fonden.routes').then(m => m.routes),
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
